module.exports = __webpack_public_path__ + "static/fonts/iconfont.e852d1c3.ttf";